import { Box, CircularProgress, Grid } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'

function Loader({
  label,
  labelId = 'common.utils.loader.label',
  secondLabel,
  secondLabelId,
  className
}: {
  label?: ReactNode
  labelId?: string
  secondLabel?: ReactNode
  secondLabelId?: string
  className?: string
}) {
  const hasLabel = label !== undefined || Boolean(labelId)
  const hasSecondLabel = Boolean(secondLabel || secondLabelId)
  return (
    <Grid container direction="column" alignItems="center" justifyContent="center" {...(className && { className })}>
      <Box mb={secondLabelId ? 1.5 : 2.5}>
        <CircularProgress />
      </Box>
      {hasLabel && (
        <Typography variant="body2" color="textSecondary">
          {label || <FormattedMessage id={labelId} />}
        </Typography>
      )}
      {hasSecondLabel && (
        <Typography variant="body2" color="textSecondary">
          {secondLabel || <FormattedMessage id={secondLabelId} />}
        </Typography>
      )}
    </Grid>
  )
}

export default Loader
